import React from "react";
import { useApp } from "context";
import { Popover as MUIPopover } from "@mui/material";

export type Props = {
  anchorEl: HTMLButtonElement | null;
  onClose: () => void;
  children: React.ReactNode;
};

export const Popover = (props: Props) => {
  const { theme } = useApp();

  return (
    <MUIPopover
      sx={{
        "& .MuiPaper-root": {
          backgroundColor: theme.palette.background.accent,
          paddingTop: "0.5rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        },
        "& .MuiChip-root": {
          margin: "0.5rem",
          marginTop: "0",
        },
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={!!props.anchorEl}
      anchorEl={props.anchorEl}
      onClose={props.onClose}
    >
      {props.children}
    </MUIPopover>
  );
};
